import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-components/fa-icon';
import styles from './index.css';

export default class Star extends withViewComponent(styles)() {
  static props = ['value'];

  get value() {
    return parseInt(this.getAttribute('value'), 10);
  }

  set value(newValue) {
    this.setAttribute('value', newValue);
  }

  updated({ value }) {
    var icons = [];
    for (var i = 0; i < value; i++) {
      icons.push(`<upd-fa-icon name="star"></upd-fa-icon>`);
    }

    this.render`${icons}`;
  }
}

customElements.define('upd-moveiq-star', Star);
